import { AsyncPipe, TitleCasePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { PopoverModule } from 'primeng/popover';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { AvatarModule } from 'primeng/avatar';
import { SelectModule } from 'primeng/select';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { StaffStoreService } from '@fitness-force/api';
@Component({
  selector: 'client-representative',
  templateUrl: './client-representative.component.html',
  styleUrls: ['./client-representative.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AvatarModule,
    SelectModule,
    StyleClassModule,
    ShortNamePipe,
    PopoverModule,
    AsyncPipe,
    TitleCasePipe,
  ],
})
export class ClientRepresentativeComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly staffStoreService = inject(StaffStoreService);

  columnData: Observable<any> = new BehaviorSubject(null);
  dataProperty: string = '';
  allStaffs: any = [];
  accessedStaffs: any = [];
  staff$ = new BehaviorSubject(null);

  ngOnInit(): void {
    combineLatest([this.columnData]).subscribe((res: any) => {
      this.getStaffDetails(res[0].client_representative_id);
    });
  }
  getStaffDetails(sId: any) {
    if (this.allStaffs) {
      this.staffStoreService.getStaffById(sId).subscribe((staff: any) => {
        this.staff$.next(staff);
      });
      // const staffIdFormStore = this.allStaffs.find((s:any) => s.id == sId)
      // if(staffIdFormStore){
      //   this.staff$.next(staffIdFormStore)
      // }
      // else if(this.accessedStaffs.find((s:any) => s.id == sId)){
      //   this.staff$.next(this.accessedStaffs.find((s:any) => s.id == sId))
      // }
    }
  }
}
